import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPaymentsStore, TPayment, TPaymentSucceededActionPayload } from '../../../types';
import { buyChest } from '../chests/asyncActions';
import { cancelPayment, getPayments } from './asyncActions';
import { buyStoreItem } from '../store/asyncActions';

const initialState: IPaymentsStore = {
  list: [],
  loading: false,
};

const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    paymentSucceeded: (state, action: PayloadAction<TPaymentSucceededActionPayload>) => {
      const paymentIdx = state.list.findIndex((p) => p.id === action.payload.id);

      if (paymentIdx !== -1) {
        state.list[paymentIdx].status = 'success';
      }
    },
  },
  extraReducers: (builder) => builder.addCase(getPayments.fulfilled, (state, action: PayloadAction<TPayment[]>) => {
    state.list = action.payload;
    state.loading = false;
  }).addCase(getPayments.pending, (state) => {
    state.loading = true;
  }).addCase(getPayments.rejected, (state) => {
    state.loading = false;
  }).addCase(buyChest.fulfilled, (state, action) => {
    state.list = [...state.list, action.payload];

    return state;
  })
    .addCase(cancelPayment.fulfilled, (state, action) => {
      const filtered = state.list.filter((p) => p.id !== action.meta.arg.id);

      return { ...state, list: filtered };
    })
    .addCase(buyStoreItem.fulfilled, (state, action) => {
      if (action.payload.type === 'telegram') {
        state.list = [...state.list, action.payload.data];
      }
    }),
});

export const { paymentSucceeded } = paymentsSlice.actions;

export const PaymentsReducer = paymentsSlice.reducer;
